import React from 'react';
// import X from '../../icons/X';
// import Check from '../../icons/Check';

export interface INavSpinnerData {
    label: string;
    spinnerClassName?: string;   // extra classes for wrapper
    spinnerStyles?: React.CSSProperties;
    wrapperClassName?: string;   // extra classes for wrapper
}

export const NavSpinner: React.FC<INavSpinnerData> = ({
  label = 'Loading...',
  spinnerClassName = "inset-0",
  spinnerStyles = undefined,
  wrapperClassName = ""
}) => {
    return (
        <div className={`w-80 h-10 rounded-lg inline-flex justify-start text-white items-center gap-2.5 overflow-hidden bg-buttons-primary ${wrapperClassName}`}>
            <div className={`m-auto z-10 flex items-center justify-cente backdrop-blur-sm in ${spinnerClassName}`} style={spinnerStyles}>
                <span className="">{label}&nbsp;</span>
                {/* Preline/Tailwind spinner */}
                <div
                    className="inline-flex m-auto h-6 w-6 rounded-full border-2 border-current border-r-transparent animate-spin align-[-0.125em] text-blue-400"
                    role="status"
                    aria-label="Loading"
                >&nbsp;</div>
            </div>
        </div>
    );
};
